import { getItem, setItem } from "owa-local-storage";
import toggleLightRP from "../actions/toggleLightRP";

export function getIsLightRPOnFromStorage(): boolean {
    return JSON.parse(getItem(window, "IS_LIGHT_RP_ON_SETTING") || JSON.stringify(false)) as boolean;
}

export function saveIsLightRPOnToStorage(currentValue: boolean): void {
    setItem(window, "IS_LIGHT_RP_ON_SETTING", JSON.stringify(currentValue));
}

// Enable other sessions to update store if local storage changes
window.addEventListener("storage", (event: StorageEvent) => {
    if (event.key === "olk-IS_LIGHT_RP_ON_SETTING") {
        /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
         * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
         *	> Function toggleLightRP called at module scope is not allowed. This may cause unwanted side effects. */
        toggleLightRP();
    }
});
